module.exports = __webpack_public_path__ + "static/media/play-icon.1c8d23f5.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/FM/play-icon.png
// module id = 528
// module chunks = 1